<script>
	const analyticsUtilities = require('utilities/analyticsUtilities');

	const OUTBOUND_LINK = analyticsUtilities.events.OUTBOUND_LINK;

	module.exports = {
		props: {
			href: {
				type: String,
				required: true
			},
			target: {
				default: '_blank'
			},
			onClick: {
				type: Function,
				default: function (e) {}
			},
			dataOutboundLink: {
				type: String,
				default: null
			}
		},
		methods: {
			onLinkClick() {
				const path = this.href;
				const tag = this.dataOutboundLink;

				if (this.onClick) {
					this.onClick.apply(this, arguments);
				}

				if (tag) {
					analyticsUtilities.fireEvent(OUTBOUND_LINK, {
						path,
						tag
					});
				}
			}
		}
	};
</script>
<template>
	<a
		:href="href"
		:target="target"
		@click="onLinkClick"
		><slot></slot
	></a>
</template>
